<template>
  <div v-if="!isMobile()">
    <div class="page-header clear-filter" filter-color="black2">
      <img src="/img/mydrago/img-bg-mydrago.png" width="100%" height="400px" />
      <div
        class="bg_bonus-area"
        v-bind:style="{ height: getTotalHeight() }"
      ></div>
      <div
        style="
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0px;
          left: 0px;
        "
      >
        <img
          src="/breed/select-bg.png"
          style="position: absolute; top: 230px; left: calc(50% - 696px)"
        />
        <div class="SELECT-BREED-DRAGO">Select the Drago to breed</div>
      </div>      
      <div
        style="
          position: absolute;
          top: 460px;
          left: calc((100% - 1360px) / 2);
          width: 1360px;
          border: solid 0 #000;
          background-color: #020520;
        "
        v-bind:style="{ height: getListHeight() }"
      >
      <div v-if="!isProperNetwork">
          <div class="warningInfo">
            <img src="/img/renewal/icon_info.png" alt="경고 메시지" />
            <span>Wrong network. Click the button to change to Arena-Z Mainnet.</span>
            <div class="ChangeWrap">
              <button @click="changeNetwork()">
                <span><img src="/img/renewal/icon_az.png" /></span>
                <p>Arena-Z</p>
              </button>
            </div>
          </div>
        </div>
        <div v-if="myDragos.length == 0">
          <div
            class="bg-empty-list"
            style="
              position: absolute;
              left: calc(50% - 40px);
              top: calc(50% - 40px);
            "
          >
            <img src="/img/genesis/select-area-drago.png" />
          </div>
          <div
            style="
              position: absolute;
              top: 480px;
              width: 100%;
              font-family: Poppins;
              font-size: 20px;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.6;
              letter-spacing: normal;
              text-align: center;
              color: #fff;
            "
          >
            You don't have any dragos.
          </div>
        </div>
        <div v-else>
          <div
            v-for="(drago, dragoIndex) in myDragos"
            v-bind:key="dragoIndex"
            style="position: absolute"
            class="breed-card-drago"
            v-bind:style="{
              top: getTop(dragoIndex),
              left: getLeft(dragoIndex),
            }"
          >
            <div class="breed-card-drago-top">
              <div
                style="
                  position: absolute;
                  left: 0px;
                  top: 0px;
                  width: 200px;
                  height: 200px;
                  cursor: pointer;
                "
                @click="onClickDrago(drago)"
              >
                <img
                  v-bind:src="getDragoAsset(drago.tokenId)"
                  width="200px"
                  height="200px"
                  style="position: absolute; left: 0px; top: 0px"
                />
                <div
                  v-if="
                    (selectedDrago[0] != null &&
                      selectedDrago[0].drago.tokenId == drago.tokenId) ||
                    (selectedDrago[1] != null &&
                      selectedDrago[1].drago.tokenId == drago.tokenId)
                  "
                  class="drago-select-frame"
                  style="position: absolute; left: 40px; top: 80px"
                >
                  <div
                    class="drago-select-check-bg"
                    style="position: absolute; left: 6px; top: 6px"
                  >
                    <img src="/img/breed/icon-arr.png" />
                    <span
                      style="
                        font-family: Poppins;
                        font-size: 14px;
                        font-weight: 500;
                        text-align: left;
                        color: #fff;
                        position: absolute;
                        left: 40px;
                        top: 4px;
                      "
                    >
                      Select
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="breed-card-drago-bottom">
              <div
                class="breed-card-name-text"
                style="position: absolute; top: 15px; left: 20px"
              >
                <img src="/img/breed/icon-breeding.png" />
                <span style="padding-left: 10px">{{ drago.breed }} / 7</span>
              </div>
              <div
                class="breed-card-tokenid-text"
                style="position: absolute; top: 15px; right: 20px"
              >
                #{{ drago.tokenId }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          width: 1360px;
          height: 1102px;
          border: solid 0 #000;
          background-image: linear-gradient(to top, #360694, #590699);
          position: absolute;
          left: calc((100% - 1360px) / 2);
        "
        v-bind:style="{ top: getTopBreeding() }"
      >
        <div
          v-for="selectedIdx in [0, 1]"
          v-bind:key="selectedIdx"
          style="width: 632px; height: 1022px; position: absolute; top: 40px"
          v-bind:style="getSelectedDragoStyle(selectedIdx)"
        >
          <div
            class="bg_drago"
            style="position: absolute; top: 0px; left: 0px"
            v-bind:id="`drago-detail-${selectedIdx}`"
          ></div>
          <div
            v-if="selectedDrago[selectedIdx] != null"
            style="
              width: 100%;
              height: 60px;
              position: absolute;
              top: 0px;
              left: 0px;
              opacity: 0.5;
              border: solid 0 #000;
              background-color: #3e059b;
            "
          ></div>
          <div
            v-if="selectedDrago[selectedIdx] != null"
            style="
              width: 100%;
              height: 60px;
              position: absolute;
              top: 0px;
              left: 0px;
            "
          >
            <div
              style="
                float: left;
                font-family: Poppins;
                font-size: 16px;
                font-weight: 600;
                text-align: left;
                color: #fff;
                margin-left: 30px;
                margin-top: 18px;
              "
            >
              Breed Count<span style="margin-left: 10px"
                >{{ selectedDrago[selectedIdx].drago.breed }} / 7</span
              >
            </div>
            <div
              style="
                float: right;
                font-family: Poppins;
                font-family: Poppins;
                font-size: 16px;
                font-weight: 600;
                text-align: right;
                color: #fff;
                margin-right: 30px;
                margin-top: 20px;
              "
            >
              #{{selectedDrago[selectedIdx].drago.tokenId}}
            </div>
          </div>
          <div
            v-if="selectedDrago[selectedIdx] == null"
            style="
              width: 632px;
              height: 500px;
              position: absolute;
              left: 0px;
              top: 0px;
              background-image: url('/img/breed/blank-drago.webp');
            "
          ></div>
          <div
            style="
              width: 632px;
              height: 70px;
              position: absolute;
              left: 0px;
              top: 500px;
              border: solid 0 #000;
              background-color: #1f0e53;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              text-align: center;
              color: #4f32bd;
            "
          >
            <div
              @click="$set(selectedTab, selectedIdx, 0)"
              v-if="
                selectedTab[selectedIdx] == 0 &&
                selectedDrago[selectedIdx] != null
              "
              style="
                float: left;
                width: 50%;
                cursor: pointer;
                background-image: url('/img/breed/tap-on-bg.png');
                color: #fff;
                height: 70px;
                padding-top: 20px;
              "
            >
              Stats
            </div>
            <div
              @click="$set(selectedTab, selectedIdx, 0)"
              v-if="
                selectedTab[selectedIdx] != 0 ||
                selectedDrago[selectedIdx] == null
              "
              style="
                float: left;
                width: 50%;
                cursor: pointer;
                height: 70px;
                padding-top: 20px;
              "
            >
              Stats
            </div>
            <div
              @click="$set(selectedTab, selectedIdx, 1)"
              v-if="
                selectedTab[selectedIdx] == 1 &&
                selectedDrago[selectedIdx] != null
              "
              style="
                float: right;
                width: 50%;
                cursor: pointer;
                background-image: url('/img/breed/tap-on-bg.png');
                color: #fff;
                height: 70px;
                padding-top: 20px;
              "
            >
              Genes
            </div>
            <div
              @click="$set(selectedTab, selectedIdx, 1)"
              v-if="
                selectedTab[selectedIdx] != 1 ||
                selectedDrago[selectedIdx] == null
              "
              style="
                float: right;
                width: 50%;
                cursor: pointer;
                height: 70px;
                padding-top: 20px;
              "
            >
              Genes
            </div>
          </div>
          <div
            style="
              width: 632px;
              height: 452px;
              position: absolute;
              left: 0px;
              top: 570px;
            "
            v-if="
              selectedDrago[selectedIdx] != null &&
              selectedTab[selectedIdx] == 0
            "
          >
            <div
              style="
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0px;
                top: 0px;
                opacity: 0.5;
                border: solid 0 #000;
                background-color: #2e196e;
              "
            ></div>
            <div
              style="
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0px;
                top: 0px;
              "
            >
              <div
                style="
                  margin-left: 30px;
                  margin-top: 30px;
                  width: 572px;
                  height: 30px;
                  font-family: Poppins;
                  font-size: 14px;
                  text-align: left;
                  color: #7353ed;
                "
              >
                <div style="float: left; width: 134px">Parts</div>
                <div style="float: left; width: 341px">Ability</div>
                <div style="float: left">Value</div>
              </div>
              <div
                style="
                  margin-left: 30px;
                  width: 572px;
                  height: 1px;
                  opacity: 0.3;
                  border: solid 0 #000;
                  background-color: #7353ed;
                "
              ></div>
              <div
                v-for="slotIdx in [0, 1, 2, 3, 4, 5, 6]"
                v-bind:key="slotIdx"
                style="
                  margin-left: 30px;
                  margin-top: 12px;
                  margin-bottom: 12px;
                  width: 572px;
                  height: 40px;
                  font-family: Poppins;
                  font-size: 13px;
                  text-align: left;
                  color: #fff;
                "
              >
                <div style="float: left; width: 134px">
                  <div
                    style="float: left"
                    v-bind:style="{
                      backgroundImage:
                        'url(' + getPartsFrame(selectedIdx, slotIdx) + ')',
                    }"
                  >
                    <img v-bind:src="getPartsImg(selectedIdx, slotIdx)" />
                  </div>
                  <div
                    style="float: left; margin-left: 20px; margin-top: 13px"
                    v-bind:style="{
                      color: getPartsColor(selectedIdx, slotIdx),
                    }"
                  >
                    {{ partsName[slotIdx] }}
                  </div>
                </div>
                <div
                  style="
                    float: left;
                    width: 331px;
                    margin-top: 13px;
                    vertical-align: middle;
                    margin-right: 10px;
                  "
                >
                  {{
                    abilityName[
                      selectedDrago[selectedIdx].dragoStats[slotIdx].ability
                        .code
                    ]
                  }}
                </div>
                <div style="float: left; margin-top: 13px">
                  <span style="float: left">
                    +{{
                      (
                        selectedDrago[selectedIdx].dragoStats[slotIdx].ability
                          .value * 100
                      ).toFixed(1)
                    }}%
                  </span>
                  <span style="float: left; margin-left: 8px; color: #2bd690">
                    +{{
                      (
                        selectedDrago[selectedIdx].dragoStats[slotIdx].bonus *
                        100
                      ).toFixed(1)
                    }}%
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            style="
              width: 632px;
              height: 452px;
              position: absolute;
              left: 0px;
              top: 570px;
            "
            v-if="
              selectedDrago[selectedIdx] != null &&
              selectedTab[selectedIdx] == 1
            "
          >
            <div
              style="
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0px;
                top: 0px;
                opacity: 0.5;
                border: solid 0 #000;
                background-color: #2e196e;
              "
            ></div>
            <div
              style="
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0px;
                top: 0px;
              "
            >
              <div
                style="
                  margin-left: 30px;
                  margin-top: 30px;
                  width: 572px;
                  height: 30px;
                  font-family: Poppins;
                  font-size: 14px;
                  text-align: left;
                  color: #7353ed;
                "
              >
                <div style="float: left; width: 134px">Parts</div>
                <div style="float: left; width: 219px">Dominant</div>
                <div style="float: left; width: 219px">Recessive</div>
              </div>
              <div
                style="
                  margin-left: 30px;
                  width: 572px;
                  height: 1px;
                  opacity: 0.3;
                  border: solid 0 #000;
                  background-color: #7353ed;
                "
              ></div>
              <div
                v-for="slotIdx in [0, 1, 2, 3, 4, 5, 6]"
                v-bind:key="slotIdx"
                style="
                  margin-left: 30px;
                  margin-top: 12px;
                  margin-bottom: 12px;
                  width: 572px;
                  height: 40px;
                  font-family: Poppins;
                  font-size: 13px;
                  text-align: left;
                  color: #fff;
                "
              >
                <div style="float: left; width: 134px">
                  <div
                    style="float: left"
                    v-bind:style="{
                      backgroundImage:
                        'url(' + getPartsFrame(selectedIdx, slotIdx) + ')',
                    }"
                  >
                    <img v-bind:src="getPartsImg(selectedIdx, slotIdx)" />
                  </div>
                  <div
                    style="float: left; margin-left: 20px; margin-top: 13px"
                    v-bind:style="{
                      color: getPartsColor(selectedIdx, slotIdx),
                    }"
                  >
                    {{ partsName[slotIdx] }}
                  </div>
                </div>
                <div style="float: left; width: 219px; margin-top: 13px">
                  {{ getPartsAttr(selectedIdx, slotIdx, true) }}
                </div>
                <div style="float: left; width: 219px; margin-top: 13px">
                  {{ getPartsAttr(selectedIdx, slotIdx, false) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <img
          src="/img/breed/icon_plus.png"
          style="position: absolute; top: 233px; left: calc(50% - 59px)"
        />
      </div>
      <div
        style="
          width: 1360px;
          height: 270px;
          position: absolute;
          left: calc((100% - 1360px) / 2);
          border: solid 0 #fff;
          background-color: #16003e;
        "
        v-bind:style="{ top: getTopBreed() }"
      >
        <div
          style="
            position: absolute;
            top: 40px;
            left: 553px;
            font-family: Poppins;
            font-size: 16px;
            font-weight: 500;
            line-height: 1.5;
            text-align: left;
            color: #0a61ef;
          "
        >
          COST
        </div>
        <div
          style="
            position: absolute;
            top: 40px;
            left: 636px;
            font-family: Poppins;
            font-size: 20px;
            font-weight: 600;
            line-height: 1.2;
            text-align: left;
            color: #fff;
          "
        >
          {{ (getBreedCost(0)[0] + getBreedCost(1)[0]) | comma }} LOKA +
          {{ (getBreedCost(0)[1] + getBreedCost(1)[1]) | comma }} DST
        </div>
        <div style="position: absolute; top: 80px; width: 100%; font-family: Poppins;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.5;
            text-align: center;
            color: #ff0000;">
            * The actual breeding cost of a selected Drago may differ from the cost shown when the Drago is already undergoing the breeding process.
        </div>
        <div
          v-if="err == 0 || err != 0"
          style="
            position: absolute;
            top: 90px;
            left: calc(50% - 292px);
            width: 584px;
            height: 88px;
            margin: 39px 0 0;
            padding: 37px 262px;
            border: solid 0 #000;
            background-color: #06f;
            font-family: Poppins;
            font-size: 20px;
            font-weight: 600;
            line-height: 1.2;
            text-align: center;
            color: #fff;
            padding-top: 33px;
            cursor: pointer;
          "
          @click="onBreed()"
        >
          BREED
        </div>
        <!-- <div
          v-else
          style="
            position: absolute;
            top: 90px;
            left: calc(50% - 292px);
            width: 584px;
            height: 88px;
            margin: 39px 0 0;
            padding: 37px 262px;
            border: solid 0 #000;
            background-color: #333333;
            font-family: Poppins;
            font-size: 20px;
            font-weight: 600;
            line-height: 1.2;
            text-align: center;
            color: #fff;
            padding-top: 33px;
          "
        >
          BREED
        </div> -->
        <div v-if="err == 1" style="position: absolute; top: 240px; width: 100%; font-family: Poppins;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.5;
            text-align: center;
            color: #ff0000;">
            * Breeding is not possible for Dragos from the same parent
        </div>
        <div v-if="err == 2" style="position: absolute; top: 240px; width: 100%; font-family: Poppins;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.5;
            text-align: center;
            color: #ff0000;">
            * Breeding is not possible between a Drago and its parent.
        </div>
        <div v-if="err == 3" style="position: absolute; top: 240px; width: 100%; font-family: Poppins;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.5;
            text-align: center;
            color: #ff0000;">
            * The Drago exceeded its max breeding count
        </div>
      </div>
      <div
        v-if="selectedDrago[0] != null && selectedDrago[1] != null"
        style="width: 100%; height: 973px; position: absolute; left: 0px"
        v-bind:style="{ top: getTopProbability() }"
      >
        <div
          style="
            width: 100%;
            height: 143px;
            border: solid 0 #000;
            background-image: linear-gradient(to right, #741286, #360694);
            font-family: Poppins;
            font-size: 32px;
            font-weight: 600;
            text-align: center;
            color: #fff;
            padding-top: 20px;
          "
        >
          EXPECTED PROBABILITY<br />
          <span style="font-size: 14px; font-weight: 500">
            Genetic properties by region
          </span>
        </div>
        <div
          style="
            width: 100%;
            height: 830px;
            border: solid 0 #fff;
            background-color: #16003e;
            position: absolute;
            top: 143px;
            left: 0px;
          "
        >
          <img
            src="/img/breed/triangle.png"
            style="position: absolute; left: calc(50% - 12px); top: 0px"
          />
          <div
            style="
              margin-top: 70px;
              font-family: Poppins;
              font-size: 20px;
              font-weight: 500;
              line-height: 1.2;
              text-align: center;
              color: #fff;
            "
          >
            Expected Probability by Part
          </div>
          <div
            style="
              width: 1296px;
              height: 552px;
              margin-top: 40px;
              margin-left: calc(50% - 648px);
            "
          >
            <div
              style="
                float: left;
                width: 308px;
                height: 260px;
                margin: 8px 8px 8px 8px;
                border: solid 0 #000;
                background-color: #1f0e53;
              "
              v-for="probParts in [0, 1, 2, 3, 4, 5, 6]"
              v-bind:key="probParts"
            >
              <div
                style="
                  width: 308px;
                  height: 70px;
                  border: solid 0 #000;
                  background-color: #3e059b;
                  padding-top: 23px;
                  font-family: Poppins;
                  font-size: 16px;
                  text-align: center;
                  color: #fff;
                "
              >
                {{ partsName[probParts] }}
              </div>
              <div
                style="
                  width: 248px;
                  height: 160px;
                  margin-top: 30px;
                  margin-left: 30px;
                "
              >
                <div
                  v-for="(prob, partsIdx) in getProbability(probParts)"
                  v-bind:key="partsIdx"
                  style="
                    width: 100%;
                    heiht: 30px;
                    font-family: Poppins;
                    font-size: 14px;
                    text-align: left;
                    color: #fff;
                  "
                >
                  <div style="float: left; width: 200px">
                    {{ attrName[prob[0]] }}
                  </div>
                  <div style="float: right; text-align: right">
                    {{ prob[1] }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        position: fixed;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: #00000099;
        cursor: pointer;
        z-index: 900;
      "
      v-if="
        modals.claim_breed == true ||
        modals.transaction_breed == true
      "
      @click="closeAllPopup()"
    ></div>
    <div
      v-if="modals.claim_breed"
      style="
        position: fixed;
        top: calc((100% - 674px) / 2);
        left: calc((100% - 605px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 674px;
        height: 605px;
        background-image: url('/img/genesis/popup-base.png');
        z-index: 10000;
      "
    >
      <div
        style="
          position: absolute;
          left: calc((100% - 300px) / 2);
          top: calc((100% - 300px) / 2);
          width: 300px;
          height: 300px;
        "
      >
        <img v-bind:src="getEggAsset(breed_token_id)" />
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          left: 17px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="onClickOK()"
          class="popup-btn2"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          OK
        </div>
      </div>
    </div>
    <div
      v-if="modals.transaction_breed"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text2"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Breed processing
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 5%;
          top: 110px;
          width: 90%;
          height: 200px;
        "
      >
        Wait for breeding...<br /><br />
        It may take up to 20-30 minutes depending on the Ethereum network
        situation.<br /><br />
        Your transaction hash is <br /><a
          v-bind:href="`https://explorer.arena-z.gg/tx/${tx_id}`"
          target="_blank"
          style="color: #000; text-decoration: underline"
          >{{ tx_id.substring(0, 30) }}<br />{{ tx_id.substring(30) }}</a
        >
      </div>
      <div
        id="loading-image"
        style="position: absolute; left: calc(50% - 40px); bottom: 140px"
      ></div>
      <div
        style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="onClickOKBreeding()"
          class="popup-btn2"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          OK
        </div>
      </div>
    </div>
  </div>
  <div v-else></div>
</template>
<script>
import { Parallax } from "@/components";
import config from "../config.js";
import axios from "axios";
import moment from "moment";
import {
  connectWallet,
  send,
  changeNetwork,
  checkLoka,
  getNetwork,
  packUint256,
} from "../utils/wallet";

export default {
  name: "Breed",
  bodyClass: "breed-page",
  components: {
    Parallax,
  },
  mounted: async function () {
    await connectWallet(this.$store);
    this.networkId = await getNetwork();
    this.getDragoInventory();
  },
  beforeDestroy() {},
  computed: {
    isProperNetwork() {
      return this.networkId == config.network.arenaz;
    }
  },
  methods: {
    async changeNetwork() {
      this.networkId = await changeNetwork(config.network.arenaz);
    },
    getEggAsset(id) {
      return `${config.api.egg_url}/${id}`;
    },
    getPartsColor(idx, slot) {
      if (this.selectedDrago[idx] == null) {
        return "#fff";
      }
      if (this.selectedDrago[idx].drago.datas == null) {
        return "#fff";
      }
      let grade = this.selectedDrago[idx].drago.datas[3 + slot * 5];
      if (grade == 1) {
        return "#fff";
      }
      return "#ffde1b";
    },
    getPartsImg(idx, slot) {
      if (this.selectedDrago[idx] == null) {
        return "";
      }
      if (this.selectedDrago[idx].drago.datas == null) {
        return "";
      }
      const partsName = ["horn", "eye", "head", "body", "wing", "leg", "tail"];
      const attrName = ["red", "blue", "yellow", "green", "purple"];
      let partsAttr = this.selectedDrago[idx].drago.datas[3 + slot * 5 + 2] - 1;
      return `/img/parts/icon_${partsName[slot]}_${attrName[partsAttr]}.png`;
    },
    getPartsFrame(idx, slot) {
      if (this.selectedDrago[idx] == null) {
        return "";
      }
      if (this.selectedDrago[idx].drago.datas == null) {
        return "";
      }
      const gradeName = ["frame_drago_epic", "frame_drago_legend"];
      let grade = this.selectedDrago[idx].drago.datas[3 + slot * 5];
      if (grade == 1) {
        return "";
      }
      return `/img/parts/${gradeName[grade - 1]}.png`;
    },
    getPartsAttr(idx, slot, dominant) {
      if (this.selectedDrago[idx] == null) {
        return "";
      }
      if (this.selectedDrago[idx].drago.datas == null) {
        return "";
      }
      if (dominant) {
        let partsCode =
          this.selectedDrago[idx].drago.datas[3 + slot * 5 + 1] - 1;
        let partsAttr =
          this.selectedDrago[idx].drago.datas[3 + slot * 5 + 2] - 1;
        let code = partsCode + partsAttr * 10;
        return this.attrName[code];
      } else {
        let partsCode =
          this.selectedDrago[idx].drago.datas[3 + slot * 5 + 3] - 1;
        let partsAttr =
          this.selectedDrago[idx].drago.datas[3 + slot * 5 + 4] - 1;
        let code = partsCode + partsAttr * 10;
        return this.attrName[code];
      }
    },
    getBreedCost(idx) {
      if (this.selectedDrago[idx] == null) {
        return [0, 0];
      }
      if (this.selectedDrago[idx].drago == null) {
        return [0, 0];
      }
      let breedCount = this.selectedDrago[idx].drago.breed;
      if (breedCount >= 6) {
        breedCount = 6;
      }
      return [this.lokaFees[breedCount], this.dstFees[breedCount]];
    },
    getProbability(slot) {
      if (this.selectedDrago[0] == null || this.selectedDrago[1] == null) {
        return [];
      }
      let result = [];
      for (let i = 0; i < 2; ++i) {
        for (let j = 0; j < 2; ++j) {
          let partsCode =
            this.selectedDrago[i].drago.datas[3 + slot * 5 + j * 2 + 1] - 1;
          let partsAttr =
            this.selectedDrago[i].drago.datas[3 + slot * 5 + j * 2 + 2] - 1;
          let code = partsCode + partsAttr * 10;
          let isExist = false;
          for (let k = 0; k < result.length; ++k) {
            if (result[k][0] == code) {
              isExist = true;
              if (j == 0) {
                result[k][1] += 40;
              } else {
                result[k][1] += 10;
              }
              break;
            }
          }
          if (!isExist) {
            if (j == 0) {
              result.push([code, 40]);
            } else {
              result.push([code, 10]);
            }
          }
        }
      }
      return result;
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    closeAllPopup() {
      this.closeModal('transaction_breed');
      this.closeModal('claim_breed');
    },
    closeModal(modal) {
      this.modals[modal] = false;
    },
    openModal(modal) {
      this.closeAllPopup();

      this.modals[modal] = true;
    },
    async onBreed() {
      if (this.networkId != config.network.arenaz) {
        this.$store.commit(
          "alert",
          "Wrong network. You should change network to Arena-Z mainnet."
        );
        return;
      }
      if (
        this.selectedDrago == null ||
        this.selectedDrago.length < 2 ||
        this.selectedDrago[0] == null ||
        this.selectedDrago[1] == null ||
        this.selectedDrago[0].drago == null ||
        this.selectedDrago[1].drago == null
      ){
        this.$store.commit(
          "alert",
          "Please select two dragos."
        );
        return;
      }
      console.log(
        this.selectedDrago[0].drago.tokenId,
        this.selectedDrago[1].drago.tokenId
      );
      let network = 2;//arenaz
      console.log(network, (this.getBreedCost(0)[0] + this.getBreedCost(1)[0]));
      await checkLoka(this.$store, network, (this.getBreedCost(0)[0] + this.getBreedCost(1)[0]));
      console.log("checkLoka");
      let self = this;
      let BREEDING = "0xfbbe20a9";
      let data = `${BREEDING}${packUint256(this.selectedDrago[0].drago.tokenId)}${packUint256(this.selectedDrago[1].drago.tokenId)}`;
      send(this.$store.state.account.wallet.address, process.env.VUE_APP_BREED_ADDR_AZ, data)
        .on("transactionHash", async (txHash) => {
          ++self.selectedDrago[0].drago.breed;
          ++self.selectedDrago[1].drago.breed;
          self.selectedDrago[0] = null;
          self.selectedDrago[1] = null;
          console.log("transactionHash");
          console.log(txHash);
          self.tx_id = txHash;
          self.openModal("transaction_breed");
        })
        .on("receipt", async (receipt) => {
          console.log("receipt");
          console.log(receipt);
          let tokenId = parseInt(receipt.logs[4].topics[1], 16);
          self.breed_token_id = tokenId;
          self.openModal("claim_breed");
          // resolve({result: true, data: receipt});
        })
        .on("error", (error) => {
          console.log("error");
          console.log(error);
          self.$store.commit(
            "alert",
            "Transaction canceled by user."
          );
        });
    },
    async onClickDrago(drago) {
      console.log(drago);
      this.err = 0;
      for (let i = 0; i < 2; ++i) {
        if (this.selectedDrago[i] != null) {
          if (this.selectedDrago[i].drago.tokenId == drago.tokenId) {
            this.$set(this.selectedDrago, i, null);
            this.err = -1;
            return;
          }
        }
      }      
      for (let i = 0; i < 2; ++i) {
        if (this.selectedDrago[i] == null) {
          let ret = await axios.post(`${config.api.nft_url}/market/detail`, {
            tokenId: drago.tokenId,
            address: drago.owner,
          });
          let slot = i;

          console.log(ret.data);

          if (ret.data.result == true) {
            console.log(ret.data);

            let rThis = {
              drago: ret.data.drago,
              dragoStats: ret.data.stats,
              dragoBonus: ret.data.bonus,
            };
            
            this.$set(this.selectedDrago, slot, rThis);

            for (let i = 0; i < 2; ++i) {
              if (this.selectedDrago[i] == null) {
                this.err = -1;
              }
            }
            if (this.err == 0) {
              for (let i = 0; i < 2; ++i) {
                if (this.selectedDrago[i].drago.breed >= 7) {
                  this.err = 3;
                  break;
                }
              } 
            }
            let isGenesis = false;
            if (this.err == 0) {
              for (let i = 0; i < 2; ++i) {
                if (this.selectedDrago[i].drago.tokenId <= 20000 || this.selectedDrago[i].drago.tokenId <= 20000) {
                  isGenesis = true;
                  break;
                }
              }
            }      
            if (this.err == 0 && !isGenesis) {
              if ((this.selectedDrago[0].drago.parents[0] == this.selectedDrago[1].drago.parents[0] || this.selectedDrago[0].drago.parents[0] == this.selectedDrago[1].drago.parents[1]) && (this.selectedDrago[0].drago.parents[1] == this.selectedDrago[1].drago.parents[0] || this.selectedDrago[0].drago.parents[1] == this.selectedDrago[1].drago.parents[1])) {
                this.err = 1;
              }
            }
            if (this.err == 0 && !isGenesis) {
              if ((this.selectedDrago[0].drago.tokenId == this.selectedDrago[1].drago.parents[0]) ||  (this.selectedDrago[0].drago.tokenId == this.selectedDrago[1].drago.parents[1]) || (this.selectedDrago[1].drago.tokenId == this.selectedDrago[0].drago.parents[0]) || (this.selectedDrago[1].drago.tokenId == this.selectedDrago[0].drago.parents[1])) {
                this.err = 2;
              }
            }
            console.log(this.err);

            let config = {
              showControls: false,
              jsonUrl: "/drago/drago/nft_drago.json",
              atlasUrl: "/drago/drago/nft_drago.atlas.txt",
              backgroundColor: "#07071f",
              success: function (player) {
                var indexs = [0, 0, 0, 0, 0, 0, 0];
                let data = rThis.drago.datas;
                for (let j = 0; j < 7; ++j) {
                  if (rThis.dragoStats[j].grade == 2) {
                    indexs[j] = rThis.dragoStats[j].attr * 10 + 10;
                  } else {
                    indexs[j] =
                      rThis.dragoStats[j].attr * 10 + rThis.dragoStats[j].code;
                  }
                }

                player.skeleton.setAttachment("head", `head/head_${indexs[2]}`);

                player.skeleton.setAttachment(
                  "horn_left",
                  `horn/horn_${indexs[0]}_l`
                );
                player.skeleton.setAttachment(
                  "horn_right",
                  `horn/horn_${indexs[0]}_r`
                );

                player.skeleton.setAttachment("eye", `eye/eye_${indexs[1]}`);

                player.skeleton.setAttachment("body", `body/body_${indexs[3]}`);

                player.skeleton.setAttachment(
                  "wing_left",
                  `wing/wing_${indexs[4]}_l1`
                );
                player.skeleton.setAttachment(
                  "wing_right",
                  `wing/wing_${indexs[4]}_r1`
                );

                player.skeleton.setAttachment(
                  "leg_left",
                  `leg/leg_${indexs[5]}_l`
                );
                player.skeleton.setAttachment(
                  "leg_right",
                  `leg/leg_${indexs[5]}_r`
                );

                player.skeleton.setAttachment("tail", `tail/tail_${indexs[6]}`);
              },
            };
            if (this.spines[slot] != null) {
              this.spines[slot].remove();
              let player = new spine.SpinePlayer(
                `drago-detail-${slot}`,
                config
              );
              player.tokenId = ret.data.drago.tokenId;
              this.spines[slot] = player;
            } else {
              let player = new spine.SpinePlayer(
                `drago-detail-${slot}`,
                config
              );
              player.tokenId = ret.data.drago.tokenId;
              this.spines[slot] = player;
            }
          }
          break;
        }
      }
    },
    getDragoAsset(tokenId) {
      return `${config.api.drago_url}/${tokenId}`;
    },
    getTop(index) {
      return Math.floor(index / 6) * 266 + 30 + "px";
    },
    getLeft(index) {
      return (index % 6) * 216 + 32 + "px";
    },
    getListHeight() {
      let num = this.myDragos.length;
      let row = Math.floor((num - 1) / 6) + 1;
      if (row <= 1) {
        return "346px";
      }
      return 250 * row + 16 * (row - 1) + 80 + "px";
    },
    getTopBreeding() {
      let num = this.myDragos.length;
      let row = Math.floor((num - 1) / 6) + 1;
      if (row <= 1) {
        return "806px";
      }
      return 460 + 250 * row + 16 * (row - 1) + 80 + "px";
    },
    getTopBreed() {
      let num = this.myDragos.length;
      let row = Math.floor((num - 1) / 6) + 1;
      if (row <= 1) {
        return "1908px";
      }
      return 1102 + 460 + 250 * row + 16 * (row - 1) + 80 + "px";
    },
    getTopProbability() {
      let num = this.myDragos.length;
      let row = Math.floor((num - 1) / 6) + 1;
      if (row <= 1) {
        return "2254px";
      }
      return 336 + 1102 + 460 + 250 * row + 16 * (row - 1) + 80 + "px";
    },
    getSelectedDragoStyle(selectedIdx) {
      switch (selectedIdx) {
        case 0:
        default:
          return { left: "40px" };
        case 1:
          return { right: "40px" };
      }
      return { left: "40px" };
    },
    getTotalHeight() {
      let num = this.myDragos.length;
      let row = Math.floor((num - 1) / 6) + 1;
      if (row <= 1) {
        if (this.selectedDrago[0] == null || this.selectedDrago[1] == null) {
          return "1918px";
        }
        return "2818px";
      }
      if (this.selectedDrago[0] == null || this.selectedDrago[1] == null) {
        return 1102 + 270 + 280 + 250 * row + 16 * (row - 1) + "px";
      } else {
        return 900 + 1102 + 270 + 280 + 250 * row + 16 * (row - 1) + "px";
      }
    },
    async getDragoInventory() {
      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      var ret = await axios.post(`${config.api.nft_url}/drago/inventory`, {
        address: address,
        network: 2,
        includeRent: true
      });
      console.log(ret.data);
      if (ret.data.result) {
        this.myDragos = ret.data.myDragos;
      }
    },
    async onClickOKBreeding() {
      this.closeModal("transaction_breed");
    },
    async onClickOK() {
      this.closeModal("claim_breed");
    },
  },
  watch: {
    "$store.state.account.wallet": async function (val) {
      await this.getDragoInventory();
    },
  },
  filters: {
    comma(val) {
      return Number(val).toLocaleString("en-US");
      //return String(val).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
    date(val) {
      if (val) {
        return moment(String(val)).format("YYYY-MM-DD HH:mm");
      }
    },
  },
  data: function () {
    return {
      breed_token_id: 0,
      tx_id: '',
      err: -1,
      selectedDrago: [null, null],
      selectedTab: [0, 0],
      spines: [null, null],
      networkId:0,
      modals: {
        transaction_breed: false,
        claim_breed: false
      },
      myDragos: [],
      partsName: ["Horn", "Eye", "Head", "Body", "Wing", "Leg", "Tail"],
      lokaFees: [100, 130, 170, 220, 280, 370, 500],
      dstFees: [1250, 1625, 2125, 2750, 3625, 4625, 6250],
      attrName: {
        0: "Fire Testudo",
        1: "Fire Smiley",
        2: "Fire Scaly",
        3: "Fire Spiky",
        4: "Fire Rocky",
        5: "Fire Feathery",
        6: "Fire Skully",
        7: "Fire Fairy",
        8: "Fire Steely",
        9: "Ferona",
        10: "Aqua Testudo",
        11: "Aqua Smiley",
        12: "Aqua Scaly",
        13: "Aqua Spiky",
        14: "Aqua Rocky",
        15: "Aqua Feathery",
        16: "Aqua Skully",
        17: "Aqua Fairy",
        18: "Aqua Steely",
        19: "Khionne",
        20: "Light Testudo",
        21: "Light Smiley",
        22: "Light Scaly",
        23: "Light Spiky",
        24: "Light Rocky",
        25: "Light Feathery",
        26: "Light Skully",
        27: "Light Fairy",
        28: "Light Steely",
        29: "Orko",
        30: "Terra Testudo",
        31: "Terra Smiley",
        32: "Terra Scaly",
        33: "Terra Spiky",
        34: "Terra Rocky",
        35: "Terra Feathery",
        36: "Terra Skully",
        37: "Terra Fairy",
        38: "Terra Steely",
        39: "Gaya",
        40: "Dark Testudo",
        41: "Dark Smiley",
        42: "Dark Scaly",
        43: "Dark Spiky",
        44: "Dark Rocky",
        45: "Dark Feathery",
        46: "Dark Skully",
        47: "Dark Fairy",
        48: "Dark Steely",
        49: "Ahriman",
      },
      abilityName: {
        1: "Power",
        2: "Food Production",
        3: "Lumber Production",
        4: "Stone Production",
        5: "Gold Production",
        6: "Food storage capacity",
        7: "Lumber storage capacity",
        8: "Stone storage capacity",
        9: "Gold storage capacity",
        10: "VIP point",
        11: "Troop dispatch queue",
        12: "Marching troop capacity",
        13: "Troop Limit",
        14: "Research Speed",
        15: "Resource protection",
        16: "Scout Level",
        17: "Additional building queue",
        18: "Scout limit",
        19: "Maximum troop size for Rally",
        20: "Maximum reinforcement troop size",
        21: "Food Protection capacity",
        22: "Lumber Protection capacity",
        23: "Stone Protection capacity",
        24: "Gold Protection capacity",
        25: "Treasure slot",
        26: "Wall Durability",
        27: "Wall Attack buff",
        28: "Wall Defense buff",
        29: "Hospital Capacity",
        30: "Healing Speed",
        31: "Mortality reduction",
        32: "Alliance help Count",
        33: "Alliance help Speedup",
        34: "Alliance size",
        35: "Gathering Speed",
        36: "Construction Speed",
        37: "Food Gathering Speed",
        38: "Lumber Gathering Speed",
        39: "Stone Gathering Speed",
        40: "Gold Gathering Speed",
        41: "Crystal Gathering Speed",
        42: "Caravan Stocks",
        43: "Caravan Visit Interval",
        44: "Food",
        45: "Lumber",
        46: "Stone",
        47: "Gold",
        48: "Crystal",
        49: "Speedup",
        50: "Infantry HP",
        51: "Archery HP",
        52: "Cavalry HP",
        53: "Infantry Defense",
        54: "Archery Defense",
        55: "Cavalry Defense",
        56: "Infantry Attack",
        57: "Archery Attack",
        58: "Cavalry Attack",
        59: "Infantry Speed",
        60: "Archery Speed",
        61: "Cavalry Speed",
        62: "Infantry Load",
        63: "Archery Load",
        64: "Cavalry Load",
        65: "Troops HP",
        66: "Troops Defense",
        67: "Troops Attack",
        68: "Troops Speed",
        69: "Troops Load",
        70: "T2 Infantry Unlock",
        71: "T2 Archery Unlock",
        72: "T2 Cavalry Unlock",
        73: "T3 Infantry Unlock",
        74: "T3 Archery Unlock",
        75: "T3 Cavalry Unlock",
        76: "T4 Infantry Unlock",
        77: "T4 Archery Unlock",
        78: "T4 Cavalry Unlock",
        79: "T5 Infantry Unlock",
        80: "T5 Archery Unlock",
        81: "T5 Cavalry Unlock",
        82: "Troops Training Rate",
        83: "Troops Training Speed",
        84: "Troops Training Cost",
        85: "Random Teleport",
        86: "Advanced Teleport",
        87: "Defense mortality reduction bonus",
        88: "Infantry Training Rate",
        89: "Archery Training Rate",
        90: "Cavalry Training Rate",
        91: "Infantry Training Speed",
        92: "Archery Training Speed",
        93: "Cavalry Training Speed",
        94: "Infantry Training Cost",
        95: "Archery Training Cost",
        96: "Cavalry Training Cost",
        97: "Construction speed",
        98: "Research speed",
        99: "Training speed",
        100: "Action point",
        101: "Action point regeneration",
        102: "Healing speed",
        103: "Teleport",
        104: "Teleport 2",
        105: "Teleport 3",
        106: "Package opening",
        107: "Instant harvest",
        108: "Instant recall",
        109: "Resource production",
        110: "Name change",
        111: "King's Shield",
        112: "vs Monster HP",
        113: "vs Monster Defense",
        114: "vs Monster Attack",
        115: "Summon Monster",
        116: "Summon Resources",
        117: "Action point regeneration",
        118: "Daily Free Chest",
        119: "Resource reserves",
        120: "Dispel",
        121: "Dev point",
        122: "Alliance Teleport",
        123: "Resource box",
        124: "Speedup box",
        125: "Intercontinental Teleport",
        126: "Ban Advanced Teleport",
        127: "Ban Shield",
        128: "Recruit T1 Troops",
        129: "Spawn crystal mine Lv4",
        130: "Spawn crystal mine Lv5",
        131: "Candy drop rate x2",
        132: "Experience points",
        133: "Infantry HP when composed of infantry only",
        134: "Infantry defense when composed of infantry only",
        135: "Infantry attack when composed of infantry only",
        136: "Archer HP when composed of archer only",
        137: "Archer defense when composed of archer only",
        138: "Archer attack when composed of archer only",
        139: "Cavalry HP when composed of cavalry only",
        140: "Cavalry defense when composed of cavalry only",
        141: "Cavalry attack when composed of cavalry only",
        142: "Castle defending Infantry's defense",
        143: "Infantry HP against archer",
        144: "Infantry defense under 50% HP",
        145: "Castle defending Infantry's HP",
        146: "Infantry defense when participating a rally",
        147: "Infantry attack when invading enemy kingdom",
        148: "Castle defending archer's attack",
        149: "Archer's attack against cavalry",
        150: "Archer's attack for the first 2 turns",
        151: "Archer's defense when raiding resource gathering",
        152: "Archer's HP when participating a rally",
        153: "Cavalry's speed when raiding enemy kingdom",
        154: "Cavalry speed when raiding resource gathering",
        155: "Cavalry attack when marching over 200km",
        156: "Cavalry defense when marching over 200km",
        157: "Cavalry speed when composed of cavalry only",
        158: "Troop speed when participating in a rally",
        159: "Troop attack when raiding collectors",
        160: "Troop HP when composed of all troop types",
        161: "Troop defense when composed of all troop types",
        162: "Troop attack when composed of all troop types",
        163: "Reduced action point consumption",
        164: "Troop speed against monster",
        165: "Resources gained from monster",
        166: "Item drop rate from monster",
        167: "March size against monster",
        168: "Increase buff duration",
        169: "Resource production per 10,000 troops",
        170: "Skill cooldown reduction",
        171: "Gathering speed per 10,000 troops",
        172: "Archer attack when invading enemy kingdoms",
        173: "Mastery point",
        174: "Christmas ornaments x2",
        175: "Resource gathering protection",
        176: "The first takeover points",
        177: "The defense points",
        178: "The final holders' bonus",
        179: "Troop health when defending",
        180: "Defense of troops when defending",
        181: "Troop attack when defending",
        182: "Infantry DEFENSE versus Archer",
        183: "Infantry ATTACK versus Archer",
        184: "Archery HP versus Cavalry",
        185: "Archery defense versus Cavalry",
        186: "Cavalry HP versus Infantry",
        187: "Cavalry DEFENSE versus Infantry",
        188: "Cavalry ATTACK versus Infantry",
        189: "Infantry ATTACK when defending castle",
        190: "Archery HP when defending castle",
        191: "Archery DEFENSE when defending castle",
        192: "Cavalry HP when defending castle",
        193: "Cavalry DEFENSE when defending castle",
        194: "Cavalry ATTACK when defending castle",
        195: "Infantry HP when participating a rally",
        196: "Infantry ATTACK when participating a rally",
        197: "Archery's DEFENSE when participating a rally",
        198: "Archery ATTACK when participating a rally",
        199: "Cavalry HP when participating a rally",
        200: "Cavalry DEFENSE when participating a rally",
        201: "Cavalry ATTACK when participating a rally",
        202: "Reconnaissance distance",
        203: "March speedup",
        204: "Archer speed when composed of archer only",
        205: "Infantry speed when composed of infantry only",
        206: "Troop HP when participating in a rally",
        207: "Troop DEFENS when participating in a rally",
        208: "Troop ATTACK when participating in a rally",
        209: "Enemy Troop HP Debuff",
        210: "Enemy Troop Defense Debuff",
        211: "Enemy Troop Attack Debuff",
        212: "drago slots",
        213: "defence drago slots",
        214: "anniversary decoration x2",
        215: "resource mint slots",
      },
    };
  },
};
</script>
<style>
.page-header {
  max-height: none !important;
}

.bg_bonus-area {
  width: 100%;
  border: solid 0 #000;
  background-color: #04050d;
}

.SELECT-BREED-DRAGO {
  position: absolute;
  width: 800px;
  height: 80px;
  top: 340px;
  left: calc(50% - 400px);
  background-image: linear-gradient(to right, #ff9c00, #f4ff3f),
    linear-gradient(to bottom, #fff600, #fff600);
  font-size: 36px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: -1.8px;
  text-align: center;
  color: #fff600;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.breed-card-drago {
  width: 200px;
  height: 250px;
  border-radius: 8px;
  border: solid 0 #000;
  background-color: #fff;
}

.breed-card-drago-top {
  width: 200px;
  height: 200px;
  position: absolute;
  top: 0px;
  left: 0px;
}

.breed-card-drago-bottom {
  width: 200px;
  height: 53px;
  position: absolute;
  top: 200px;
  left: 0px;
}

.breed-card-name-text {
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #202431;
}

.breed-card-tokenid-text {
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #202431;
}

.bg_drago {
  width: 632px;
  height: 500px;
  border-radius: 20px;
  border: solid 0 #000;
  background-color: #07071f;
}

.drago-select-frame {
  width: 120px;
  height: 40px;
  border-radius: 20px;
  border: solid 0 #000;
  background-color: #0d6eff;
}

.drago-select-check-bg {
  width: 28px;
  height: 28px;
  padding: 2px 6px;
  border-radius: 14px;
  border: solid 0 #000;
  background-color: #fff;
}

.popup-head-text2 {
  font-family: Poppins;
  font-size: 24px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

.popup-btn2 {
  width: 280px;
  height: 70px;
  border-radius: 2px;
  border: solid 0 #000;
  background-color: #0a1844;
  font-family: Poppins;
  padding-top: 22px;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

/* 2025업데이트 1/17 */
.warningInfo {
  margin-top:-20px;
  display: flex; align-items: center; justify-content: center;
}
.warningInfo > span {
  padding: 0 0 0 10px;
  color: #f85e49; font-size: 18px;
}
.warningInfo .ChangeWrap {
  margin: 0 0 0 30px;
}
.warningInfo .ChangeWrap button {
  display: flex; align-items: center;
  width: 190px; height: 48px;
  border: 0; border-radius: 4px; background-color: #3700eb;
  padding: 0 0 0 20px;
  background-image: url('/img/renewal/icon_refresh.png');
  background-repeat: no-repeat;
  background-position: 90% 50%;
}
.warningInfo .ChangeWrap button p {
  color: #fff; font-size: 18px; font-weight: 600;
  margin: 0; padding: 0 0 0 12px;
}
</style>
